import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/sa/web-sa/get-benefit.webp";

function Banner(props) {
  return (
    <div className="experienced p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Get Benefit from the Agile Approach of Our Website Development
              Company in Riyadh
            </h2>
            <p>
              Experience the agility and efficiency of our website development
              company in Riyadh. We take pride in serving our clients with
              excellence as one of the top website development companies in the
              region. We ensure that your website project stays on track and
              delivers exceptional results. Our professional team is committed
              to delivering websites with a focus on user-centric design and
              cutting-edge technology.
            </p>
            <p>
              Collaborating with a leading website development and design
              company like ours means gaining access to proven expertise. We
              understand the unique challenges and opportunities of the digital
              market in Riyadh, and we customize our solutions to meet the
              specific needs of your business. Whether you're looking to revamp
              an existing website or launch a new online platform, our team has
              the skills and resources to bring your vision to life.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book A Free Consultation!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
